import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography, Dialog, DialogContent } from '@mui/material';
import { LangSelection } from './LangSelection';
import { configKeys } from './ConfigHolder';

export const SelectionRow = ({ label, selectLabel, configKey }) => { 
  
  return (
  <Box sx={{ mb: 2, display: 'flex', flexDirection: 'row', 
           alignItems: 'center', 
		       justifyContent:'space-between',
		    }}>
    <Typography sx={{ m: 0, ml: 0, 
                      mr:1
		// flexShrink: 0 
		                }}
                    variant="body2"
    >{label}</Typography>
    <LangSelection label={selectLabel} saveLabel={[configKey]} />
  </Box>
);
}

const FirstTimeLangSelection = ({ open, onClose }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      aria-labelledby="dialog-title" 
      aria-describedby="dialog-description"
      
    >
      <DialogContent sx = {{width:'100%'}}>
        <Typography id="dialog-title" variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
          Select the languages
        </Typography>

        <SelectionRow 
          label="Language you want to learn or improve" 
		      selectLabel="Learning"
          configKey={configKeys.langLearn} 
        />
        <SelectionRow 
          label="Language you are fluent in" 
		      selectLabel = "MyLanguage"
          configKey={configKeys.langBase} 
        />
        
        <Typography id="dialog-description" variant="body2" sx={{ mb: 2, fontWeight: 'bold' }}>
          Later you can change your selection in the Profile section.
        </Typography>

        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start' }}>
          <Button 
            variant="outlined" 
            onClick={onClose}
          >
            Continue
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

FirstTimeLangSelection.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FirstTimeLangSelection;
